import { useEffect, useState } from "react";
import { Box, Container, Grid, Paper, Typography, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { instance } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";

const estadoColor = {
  "Pendiente de revisión": "#ed6c02",
  "Aprobado": "#2e7d32",
  "Rechazado": "#d32f2f"
};

function UPSE4MesesPorUpse2() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const idUpse2 = location.state?.idUpse2;
  const nombreUpse2 = location.state?.nombreUpse2;
  const anio = location.state?.anio;
  const tipoPlanificacion = location.state?.tipoPlanificacion;

  const [meses, setMeses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });

  useEffect(() => {
    if (!idUpse2) {
      navigate("/UPSE4");
      return;
    }
    instance.get(`/upse4/resumenMeses/${idUpse2}`)
      .then((res) => setMeses(res.data))
      .catch((err) => {
        setDialog({ title: "ERROR", text: err.response?.data?.message || "Error desconocido" });
        setOpenDialog(true);
      })
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUpse2]);

  const handleClickMes = (mes) => {
    if (mes.idUpse4) {
      const validar = mes.idResponsable === user.id && mes.idEstado === 1;
      navigate("/UPSE4Detalle", { state: { id: mes.idUpse4, validar } });
    } else {
      navigate("/UPSE4Agregar", {
        state: {
          idUpse2: { Id: idUpse2, Nombre: nombreUpse2 },
          mes: { Id: mes.idMes, Nombre: mes.mes }
        }
      });
    }
  };

  return (
    <Container>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate("/UPSE4")}>Volver</Button>
        <h2 style={{ textAlign: 'center', flex: 1, margin: 0 }}>{nombreUpse2} {anio ? `- ${anio}` : ''}</h2>
        <Button
          variant="outlined"
          onClick={() => navigate("/UPSE4ReporteBrecha", { state: { idUpse2, nombreUpse2, anio } })}
        >
          Ver reporte de brecha
        </Button>
      </Box>
      {tipoPlanificacion && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 2, textTransform: 'capitalize' }}>
          Tipo de planificación: {tipoPlanificacion}
        </Typography>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading}>
          <Container maxWidth="md" sx={{ marginBottom: 5 }}>
            <Grid container spacing={2}>
              {meses.map((mes) => {
                const reportado = !!mes.idUpse4;
                const color = reportado
                  ? (estadoColor[mes.estado] || "#757575")
                  : (mes.tienePlanificacion ? "#0288d1" : "#9e9e9e");

                return (
                  <Grid item xs={6} sm={4} md={3} key={mes.idMes}>
                    <Paper
                      onClick={() => handleClickMes(mes)}
                      elevation={2}
                      sx={{
                        padding: 2,
                        textAlign: 'center',
                        borderRadius: 2,
                        border: `2px ${reportado || mes.tienePlanificacion ? 'solid' : 'dashed'} ${color}`,
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 4 }
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight="bold">{mes.mes}</Typography>
                      <Typography variant="caption" sx={{ color }}>
                        {reportado ? mes.estado : (mes.tienePlanificacion ? "Pendiente de reportar" : "Sin meta · reportar")}
                      </Typography>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </LoaderBoxCircular>
      </Box>

      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </Container>
  );
}

export { UPSE4MesesPorUpse2 };
